// ArChat Auto-Normalized File
// Created: 12-03-2026 22:38:36
// Author: SIVOL® - Aldo Frias - Argentina

/**
 * Autor: SIVOL® - Aldo Frias - Argentina
 * Fecha: 11/03/2026 22:50 (Argentina - UTC-3)
 * Hook global de tema: aplica data-theme en el DOM.
 * Usado al cargar la app y desde ThemeContext para garantizar contraste correcto.
 * @file useTheme.js
 */

/**
 * Aplica el tema en document.documentElement (html) y en body (clases para CSS).
 * @param {string} theme - 'dark' | 'argentina'
 */
export function applyTheme(theme) {
  if (typeof document === 'undefined') return;
  const value = theme === 'dark' || theme === 'argentina' ? theme : 'argentina';
  const root = document.documentElement;
  root.setAttribute('data-theme', value);
  root.classList.remove('theme-dark', 'dark-mode', 'argentina-theme');
  if (value === 'dark') {
    root.classList.add('theme-dark', 'dark-mode');
  } else {
    root.classList.add('argentina-theme');
  }
  const body = document.body;
  if (body && body.classList) {
    body.classList.remove('theme-dark', 'dark-mode', 'argentina-theme');
    if (value === 'dark') {
      body.classList.add('theme-dark', 'dark-mode');
    } else {
      body.classList.add('argentina-theme');
    }
  }
  if (typeof console !== 'undefined' && console.log) {
    console.log('ARCHAT THEME:', document.documentElement.getAttribute('data-theme'));
  }
}
